export const PRODUCTION_API_URL = 'http://propertiesbackend-env.eba-cpdnwf5q.us-east-2.elasticbeanstalk.com/api/';
//export const PRODUCTION_API_URL = 'http://localhost/properties/api/';
export const PRODUCTION_WIDGET_API_URL = 'https://api.aicre.dev/';
//export const PRODUCTION_WIDGET_API_URL = 'http://localhost:3000/';
